const AdminHeader = () => (
  <div className="mb-5">
    <h2 style={{ fontSize: "2rem", fontWeight: 800, color: "#002045", letterSpacing: "-0.03em", marginBottom: 6 }}>
      Architectural Ledger
    </h2>
    <p className="text-muted" style={{ maxWidth: 560 }}>
      Global administrative control center for the ERP system.
    </p>
  </div>
);

export default AdminHeader;
